import PropTypes from 'prop-types';
import React, { Component, useContext, useState, useEffect } from 'react';
import { GlobalContext } from 'wix-rich-content-common';
import classNames from 'classnames';
import { debounce } from 'lodash';
import Tooltip from 'wix-rich-content-common/libs/Tooltip';
import { SpoilerContext } from 'ricos-context';
import { Decoration_Type } from 'ricos-schema';

var styles = {"fontElementMap":"ugZ9l","hideText":"HGTNJ","onHoverText":"nTYyj","hideBlock":"AM0Nm","smallBlur":"DMzfN","mediumBlur":"PmbXM","largeBlur":"g3NEV","hideBlock_gallery":"_0mKJt","overlay":"_-2GBO","overlay_gallery":"_7W4yT","revealSpoilerBtn":"_5AocZ","isMobile":"-O-Lr","onHoverBtn":"_-6iKo","spoilerWrapper":"ABEEa","spoilerDescription":"DE7DM","spoilerContainer":"C6QwT","spoilerContainer_Gallery":"yUKC-"};

const SPOILER_TYPE = "wix-rich-content-plugin-spoiler";

var __defProp$8 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = (obj, key, value) => key in obj ? __defProp$8(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$8(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$8(a, prop, b[prop]);
    }
  return a;
};
const SpoilerContainerIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues$3({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "33", viewBox: "0 0 32 33" }, props), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", strokeLinejoin: "round" }, /* @__PURE__ */ React.createElement("g", { stroke: "#FFF" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
  "path",
  {
    strokeLinecap: "round",
    d: "M.874 11.54c-.498.808-.498 1.82 0 2.628 1.88 3.053 6.665 9.185 14.755 9.185s12.874-6.132 14.755-9.185c.498-.809.498-1.82 0-2.629-1.881-3.053-6.665-9.186-14.755-9.186S2.755 8.486.874 11.54z",
    transform: "translate(-618 -622) translate(618 622.5) translate(.5 3)"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    strokeLinecap: "round",
    d: "M21.128 12.854c0 3.038-2.462 5.5-5.5 5.5-3.037 0-5.5-2.462-5.5-5.5s2.463-5.5 5.5-5.5c3.038 0 5.5 2.462 5.5 5.5z",
    transform: "translate(-618 -622) translate(618 622.5) translate(.5 3)"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M28.128 25.354L3.128 0.353",
    transform: "translate(-618 -622) translate(618 622.5) translate(.5 3)"
  }
))))));

class EditableTextInput extends Component {
  constructor() {
    super(...arguments);
    this.handleFocus = (e) => {
      e.stopPropagation();
      this.props.setFocusToBlock();
      this.props.setInPluginEditingMode(true);
    };
    this.handleBlur = () => this.props.setInPluginEditingMode(false);
    this.handleKeyPress = (e) => {
      const { setFocusToBlock, value } = this.props;
      if (e.key === "Enter" && setFocusToBlock && value !== "") {
        this.handleBlur();
        setFocusToBlock();
      }
    };
  }
  render() {
    const { InputComponent, value, onChange } = this.props;
    const props = {
      value,
      onChange,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onKeyPress: this.handleKeyPress,
      dir: "auto"
    };
    return React.cloneElement(InputComponent, props);
  }
}
var EditableInputWrapper = EditableTextInput;

var __defProp$7 = Object.defineProperty;
var __defNormalProp$7 = (obj, key, value) => key in obj ? __defProp$7(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$5 = (obj, key, value) => {
  __defNormalProp$7(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class RevealButton extends React.Component {
  constructor() {
    super(...arguments);
    __publicField$5(this, "onChange", (e) => {
      const oldValue = this.props.value;
      const newValue = e.target.value;
      if (e.target.scrollWidth < 229 || oldValue.length > newValue.length) {
        this.props.onChange(newValue);
      }
    });
  }
  render() {
    const { className, onRevealSpoiler, setInPluginEditingMode, setFocusToBlock, value, onChange } = this.props;
    const InputComponent = /* @__PURE__ */ React.createElement("input", { size: value.length + 1, "data-hook": "revealSpoilerContent", type: "text" });
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        className,
        onClick: onRevealSpoiler,
        "data-hook": "revealSpoilerBtn",
        type: "button"
      },
      onChange ? /* @__PURE__ */ React.createElement(
        EditableInputWrapper,
        {
          InputComponent,
          value,
          onChange: this.onChange,
          setInPluginEditingMode,
          setFocusToBlock
        }
      ) : /* @__PURE__ */ React.createElement("span", { dir: "auto" }, value)
    );
  }
}
RevealButton.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  setFocusToBlock: PropTypes.func,
  setInPluginEditingMode: PropTypes.func,
  onRevealSpoiler: PropTypes.func
};

var __defProp$6 = Object.defineProperty;
var __defNormalProp$6 = (obj, key, value) => key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$4 = (obj, key, value) => {
  __defNormalProp$6(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class SpoilerDescriptionInput extends Component {
  constructor() {
    super(...arguments);
    __publicField$4(this, "onChange", (e) => this.props.onChange(e.target.value));
    __publicField$4(this, "setTextAreaRef", (ref) => this.textAreaRef = ref);
  }
  componentDidUpdate() {
    this.fixTextAreaHeight();
  }
  fixTextAreaHeight() {
    var _a;
    if ((_a = this.textAreaRef) == null ? void 0 : _a.style) {
      this.textAreaRef.style.height = "";
      this.textAreaRef.style.height = this.textAreaRef.scrollHeight + "px";
    }
  }
  render() {
    const { className, onChange, value, setFocusToBlock, setInPluginEditingMode } = this.props;
    const InputComponent = /* @__PURE__ */ React.createElement(
      "textarea",
      {
        ref: this.setTextAreaRef,
        className,
        rows: 1,
        maxLength: 70,
        "data-hook": "spoilerTextArea"
      }
    );
    return onChange ? /* @__PURE__ */ React.createElement(
      EditableInputWrapper,
      {
        InputComponent,
        value,
        onChange: this.onChange,
        setInPluginEditingMode,
        setFocusToBlock
      }
    ) : /* @__PURE__ */ React.createElement("span", { className, dir: "auto", style: { display: "block", maxWidth: "89%" } }, value);
  }
}
SpoilerDescriptionInput.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  setFocusToBlock: PropTypes.func,
  setInPluginEditingMode: PropTypes.func
};

var __defProp$5 = Object.defineProperty;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$3 = (obj, key, value) => {
  __defNormalProp$5(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class SpoilerContainer extends React.Component {
  constructor() {
    super(...arguments);
    __publicField$3(this, "getReducedContainer", (className) => {
      const { onRevealSpoiler, pluginType, t } = this.props;
      const disabledRevealBtn = !onRevealSpoiler;
      const container = /* @__PURE__ */ React.createElement(
        SpoilerContainerIcon,
        {
          className,
          style: { cursor: !disabledRevealBtn ? "pointer" : "auto" },
          onClick: onRevealSpoiler,
          "data-hook": "revealSpoilerBtn"
        }
      );
      return disabledRevealBtn ? container : /* @__PURE__ */ React.createElement(Tooltip, { content: t(`Spoiler_Reveal_${pluginType}_CTA`), hideArrow: true }, container);
    });
    __publicField$3(this, "getExpandedContainer", (containerClassName) => {
      const {
        description,
        buttonContent,
        pluginType,
        onRevealSpoiler,
        styles,
        setInPluginEditingMode,
        setFocusToBlock,
        handleButtonContentChange,
        isMobile,
        t
      } = this.props;
      const disabledRevealBtn = !onRevealSpoiler;
      const content = buttonContent != null ? buttonContent : t(`Spoiler_Reveal_${pluginType}_CTA`);
      const buttonClassName = classNames(styles.revealSpoilerBtn, {
        [styles.revealSpoilerBtnMobile]: isMobile,
        [styles.onHoverBtn]: !disabledRevealBtn
      });
      return /* @__PURE__ */ React.createElement("div", { className: containerClassName, style: { width: "100%" } }, /* @__PURE__ */ React.createElement(
        SpoilerContainerIcon,
        {
          style: { cursor: !disabledRevealBtn ? "pointer" : "auto" },
          onClick: onRevealSpoiler
        }
      ), this.renderDescription(description), /* @__PURE__ */ React.createElement(
        RevealButton,
        {
          onRevealSpoiler,
          className: buttonClassName,
          value: content,
          onChange: handleButtonContentChange,
          setInPluginEditingMode,
          setFocusToBlock
        }
      ));
    });
  }
  renderDescription(description) {
    const {
      setInPluginEditingMode,
      pluginType,
      styles,
      handleDescriptionChange,
      setFocusToBlock,
      t
    } = this.props;
    return /* @__PURE__ */ React.createElement(
      SpoilerDescriptionInput,
      {
        setInPluginEditingMode,
        className: styles.spoilerDescription,
        value: description != null ? description : t(`Spoiler_Reveal_${pluginType}_Placeholder`),
        onChange: handleDescriptionChange,
        setFocusToBlock
      }
    );
  }
  render() {
    const { pluginType, width, height, styles } = this.props;
    const containerClassName = pluginType === "Gallery" ? styles.spoilerContainer_Gallery : styles.spoilerContainer;
    const spoilerContainer = width < 320 || height < 228 ? this.getReducedContainer(containerClassName) : this.getExpandedContainer(containerClassName);
    return spoilerContainer;
  }
}
SpoilerContainer.propTypes = {
  description: PropTypes.string,
  buttonContent: PropTypes.string,
  styles: PropTypes.object,
  pluginType: PropTypes.string,
  onRevealSpoiler: PropTypes.func,
  setFocusToBlock: PropTypes.func,
  setInPluginEditingMode: PropTypes.func,
  width: PropTypes.number,
  height: PropTypes.number,
  handleDescriptionChange: PropTypes.func,
  handleButtonContentChange: PropTypes.func,
  t: PropTypes.func,
  isMobile: PropTypes.bool
};
var SpoilerContainer$1 = SpoilerContainer;

var __defProp$4 = Object.defineProperty;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$2 = (obj, key, value) => {
  __defNormalProp$4(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const Overlay = ({ hideOverlay, pluginType }) => !hideOverlay ? /* @__PURE__ */ React.createElement(
  "div",
  {
    role: "none",
    className: pluginType === "Gallery" ? styles.overlay_gallery : styles.overlay
  }
) : null;
Overlay.propTypes = {
  hideOverlay: PropTypes.bool,
  pluginType: PropTypes.string
};
class BlockSpoilerComponent extends React.Component {
  constructor(props) {
    super(props);
    __publicField$2(this, "onResizeElement", () => {
      this.forceUpdate();
    });
    __publicField$2(this, "handleClick", (e) => {
      const { onClick } = this.props;
      const { isReveal } = this.state;
      isReveal && (onClick == null ? void 0 : onClick(e));
    });
    __publicField$2(this, "onRevealSpoiler", (e) => {
      var _a;
      const { helpers, pluginType } = this.props;
      e.preventDefault();
      this.setState({ isReveal: true });
      (_a = helpers.onViewerAction) == null ? void 0 : _a.call(helpers, SPOILER_TYPE, "Click", `reveal_${pluginType}`);
    });
    __publicField$2(this, "renderSpoilerContainer", () => {
      var _a, _b, _c, _d, _e, _f;
      const { isReveal } = this.state;
      const {
        disabledRevealSpoilerBtn,
        setFocusToBlock,
        componentData,
        pluginType,
        setInPluginEditingMode,
        handleButtonContentChange,
        handleDescriptionChange,
        isMobile,
        t,
        helpers
      } = this.props;
      const width = (_a = this.elementRef) == null ? void 0 : _a.offsetWidth;
      const height = (_b = this.elementRef) == null ? void 0 : _b.offsetHeight;
      return !isReveal && /* @__PURE__ */ React.createElement(
        SpoilerContainer$1,
        {
          styles,
          width,
          height,
          setInPluginEditingMode,
          setFocusToBlock,
          pluginType,
          description: (_d = (_c = componentData == null ? void 0 : componentData.config) == null ? void 0 : _c.spoiler) == null ? void 0 : _d.description,
          buttonContent: (_f = (_e = componentData == null ? void 0 : componentData.config) == null ? void 0 : _e.spoiler) == null ? void 0 : _f.buttonContent,
          onRevealSpoiler: !disabledRevealSpoilerBtn ? this.onRevealSpoiler : void 0,
          handleButtonContentChange,
          handleDescriptionChange,
          isMobile,
          t,
          helpers
        }
      );
    });
    __publicField$2(this, "onKeyDown", (e) => {
      if (e.key === "Enter") {
        this.handleClick(e);
      }
    });
    __publicField$2(this, "setRef", (ref) => this.elementRef = ref);
    this.state = {};
  }
  componentDidMount() {
    var _a;
    if (window == null ? void 0 : window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(debounce(this.onResizeElement, 60));
      (_a = this.resizeObserver) == null ? void 0 : _a.observe(this.elementRef);
    }
  }
  componentWillUnmount() {
    var _a;
    if (window == null ? void 0 : window.ResizeObserver) {
      (_a = this.resizeObserver) == null ? void 0 : _a.unobserve(this.elementRef);
    }
  }
  render() {
    var _a;
    const { children, pluginType, width, isMobile } = this.props;
    const { isReveal } = this.state;
    let className = "";
    let blur = "";
    if (!isReveal) {
      const isGallery = pluginType === "Gallery";
      className = isGallery ? styles.hideBlock_gallery : styles.hideBlock;
      if (!isGallery) {
        const width2 = (_a = this.elementRef) == null ? void 0 : _a.offsetWidth;
        blur = width2 < 400 ? styles.smallBlur : width2 < 700 ? styles.mediumBlur : styles.largeBlur;
      }
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: this.setRef,
        className: classNames(styles.spoilerWrapper, this.props.className, {
          [styles.isMobile]: isMobile
        }),
        style: { width },
        "data-hook": "spoilerContainer"
      },
      this.renderSpoilerContainer(),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames(className, blur),
          onClick: this.handleClick,
          role: "button",
          tabIndex: 0,
          onKeyDown: this.onKeyDown
        },
        children,
        /* @__PURE__ */ React.createElement(Overlay, { hideOverlay: isReveal, pluginType })
      )
    );
  }
}
BlockSpoilerComponent.propTypes = {
  componentData: PropTypes.object.isRequired,
  children: PropTypes.object.isRequired,
  theme: PropTypes.object,
  disabledRevealSpoilerBtn: PropTypes.bool,
  isEditableText: PropTypes.bool,
  pluginType: PropTypes.string,
  onClick: PropTypes.func,
  handleDescriptionChange: PropTypes.func,
  handleButtonContentChange: PropTypes.func,
  className: PropTypes.string,
  setFocusToBlock: PropTypes.func,
  setInPluginEditingMode: PropTypes.func,
  width: PropTypes.object,
  t: PropTypes.func,
  isMobile: PropTypes.bool,
  helpers: PropTypes.object,
  type: PropTypes.string
};
var BlockSpoilerComponent$1 = BlockSpoilerComponent;

var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
var __publicField$1 = (obj, key, value) => {
  __defNormalProp$3(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class SpoilerViewerWrapper extends Component {
  constructor(props) {
    var _a, _b, _c;
    super(props);
    this.state = {
      hasSpoiler: ((_c = (_b = (_a = props.componentData) == null ? void 0 : _a.config) == null ? void 0 : _b.spoiler) == null ? void 0 : _c.enabled) || false
    };
  }
  componentWillReceiveProps(props) {
    var _a, _b, _c;
    const hasSpoiler = ((_c = (_b = (_a = props.componentData) == null ? void 0 : _a.config) == null ? void 0 : _b.spoiler) == null ? void 0 : _c.enabled) || false;
    this.setState({ hasSpoiler });
  }
  render() {
    const { hasSpoiler } = this.state;
    const type = this.props.type.toLowerCase();
    const pluginType = type[0].toUpperCase() + type.slice(1);
    const { children } = this.props;
    const { isMobile, t } = this.context;
    return hasSpoiler ? /* @__PURE__ */ React.createElement(BlockSpoilerComponent$1, __spreadValues$2({ pluginType, isMobile, t }, this.props), children) : children;
  }
}
__publicField$1(SpoilerViewerWrapper, "contextType", GlobalContext);
__publicField$1(SpoilerViewerWrapper, "propTypes", {
  children: PropTypes.node,
  componentData: PropTypes.object,
  type: PropTypes.string
});

var __defProp$2 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const initSpoilersContentState = (contentState) => {
  let prevSpoilerStyle = "";
  const blocks = contentState.blocks.map((block) => {
    var _a;
    let isBlockContainSpoiler;
    const inlineStyleRanges = (_a = block == null ? void 0 : block.inlineStyleRanges) == null ? void 0 : _a.map((range) => {
      if (range.style === SPOILER_TYPE) {
        isBlockContainSpoiler = true;
        if (block.text.length === range.offset + range.length) {
          prevSpoilerStyle = range.offset !== 0 || prevSpoilerStyle === "" ? `SPOILER_${block.key}_${range.offset}_${range.offset + range.length}` : prevSpoilerStyle;
        }
        return __spreadProps(__spreadValues$1({}, range), {
          style: range.offset === 0 && prevSpoilerStyle !== "" ? prevSpoilerStyle : `SPOILER_${block.key}_${range.offset}_${range.offset + range.length}`
        });
      }
      return __spreadValues$1({}, range);
    });
    if (!isBlockContainSpoiler) {
      prevSpoilerStyle = "";
    }
    return __spreadProps(__spreadValues$1({}, block), {
      inlineStyleRanges
    });
  });
  return __spreadProps(__spreadValues$1({}, contentState), {
    blocks
  });
};

var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class SpoilerViewer extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "handleClick", (event) => {
      var _a, _b;
      event.preventDefault();
      this.showText();
      (_b = (_a = this.props.settings).onViewerAction) == null ? void 0 : _b.call(_a, SPOILER_TYPE, "Click", "reveal_text");
    });
    __publicField(this, "showText", () => {
      this.props.callAllCallbacks({ shouldShowText: true });
    });
    __publicField(this, "toggleOnHover", (onHover) => {
      const { isMobile } = this.context;
      !isMobile && this.props.callAllCallbacks({ onHover });
    });
    __publicField(this, "onMouseEnter", () => this.toggleOnHover(true));
    __publicField(this, "onMouseLeave", () => this.toggleOnHover(false));
    __publicField(this, "onKeyUp", (e) => {
      if (e.key === "Enter") {
        this.showText();
      }
    });
    this.state = {};
  }
  componentDidMount() {
    const { stateChangeCallBacks } = this.props;
    stateChangeCallBacks.push((newState) => this.setState(newState));
  }
  componentWillReceiveProps(nextprops) {
    const { stateChangeCallBacks } = nextprops;
    stateChangeCallBacks.push((newState) => this.setState(newState));
  }
  render() {
    const { children, dataHook } = this.props;
    const { shouldShowText, onHover } = this.state;
    const { t } = this.context;
    return shouldShowText ? children : /* @__PURE__ */ React.createElement(
      Tooltip,
      {
        content: t("Spoiler_Reveal_Tooltip"),
        tooltipOffset: { y: -15 },
        hideArrow: true,
        followMouse: true
      },
      /* @__PURE__ */ React.createElement(
        "span",
        {
          className: classNames(styles.hideText, {
            [styles.onHoverText]: onHover
          }),
          onMouseEnter: this.onMouseEnter,
          onMouseLeave: this.onMouseLeave,
          onKeyUp: this.onKeyUp,
          onClick: this.handleClick,
          role: "button",
          tabIndex: 0,
          "data-hook": dataHook
        },
        children
      )
    );
  }
}
__publicField(SpoilerViewer, "propTypes", {
  theme: PropTypes.object,
  children: PropTypes.node,
  shouldShowText: PropTypes.bool,
  callAllCallbacks: PropTypes.func,
  stateChangeCallBacks: PropTypes.array,
  dataHook: PropTypes.string,
  settings: PropTypes.object
});
__publicField(SpoilerViewer, "contextType", GlobalContext);
var SpoilerViewer$1 = SpoilerViewer;

const TextSpoiler = ({ children, spoilerData }) => {
  const { spoilerManager } = useContext(SpoilerContext);
  const { id } = spoilerData || {};
  const [isSpoilerActive, setIsSpoilerActive] = useState(id ? spoilerManager.isActive(id) : true);
  useEffect(() => {
    if (id) {
      spoilerManager == null ? void 0 : spoilerManager.registerSpoiler(id, () => setIsSpoilerActive(false));
    }
  }, []);
  const toggleSpoiler = () => {
    const { id: id2 } = spoilerData || {};
    id2 ? spoilerManager == null ? void 0 : spoilerManager.toggleSpoiler(id2) : setIsSpoilerActive(!isSpoilerActive);
  };
  return isSpoilerActive ? /* @__PURE__ */ React.createElement(
    "span",
    {
      role: "button",
      tabIndex: 0,
      onKeyDown: toggleSpoiler,
      onClick: toggleSpoiler,
      style: { filter: "blur(0.25em)", cursor: "pointer" }
    },
    children
  ) : /* @__PURE__ */ React.createElement(React.Fragment, null, children);
};
const decorator = (element, spoilerDecoration) => {
  const { spoilerData } = spoilerDecoration;
  return /* @__PURE__ */ React.createElement(TextSpoiler, { key: `spoiler-${element.key}`, spoilerData }, element);
};
const SpoilerDecorator = {
  rule: (node) => {
    var _a, _b;
    return !!((_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.some(({ type }) => type === Decoration_Type.SPOILER));
  },
  decorate: ({ element, node }) => {
    var _a, _b;
    const spoilerDecoration = (_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.find(
      ({ type }) => type === Decoration_Type.SPOILER
    );
    return decorator(element, spoilerDecoration);
  }
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginSpoiler = (config) => {
  return {
    config: __spreadValues({ initSpoilersContentState, SpoilerViewerWrapper }, config),
    type: SPOILER_TYPE,
    nodeViewDecorators: [SpoilerDecorator]
  };
};

export { SPOILER_TYPE, SpoilerViewer$1 as SpoilerViewer, SpoilerViewerWrapper, initSpoilersContentState, pluginSpoiler };
//# sourceMappingURL=viewer.js.map
